import { Channel } from "@anycable/web";

export default class extends Channel {
  static identifier = "CoworkerSitewideNotificationChannel";

  receive(data) {
    super.receive(data);
  }
}
